import { PLAYER_SEGMENT } from 'constants.js';
import { HBO_COMMUNICATION_PATH } from 'containers/HboCommunication/constants';

export const NODE_MUNDIAL_2026 = '/:country/mundial2026';
export const SET_CONTROL_PIN_TEST = '/services/user/setcontrolpin';
export const SET_CONTROL_PIN_PROD = '/:country/home/all.php';
export const SET_CONTROL_PIN_PLAYER = '/:country/:node/all.php';
export const SET_CONTROL_PIN_PLAYER_PROD = '/:player/:country/:node/all.php';

export const PREFERENCES = '/:country/home/preference';

export const LANDING = '/:country/landing';
export const REGISTER_FORM = '/:country/register';
export const COMPLETE_YOUR_INFO = '/:country/completeinfo';
export const PAYMENT = '/:country/payment';
export const CHECKOUT_REDIRECT = '/:country/checkout-redirect';
export const PROMOGATE_ONLY_CODE = '/:country/promogate';
export const PROMOGATE_ONLY_CODE_CONFIRM = '/:country/promogate/confirm';
export const PLAN_SELECT = '/:country/planselect';
export const CHECKOUT = '/:country/checkout';
export const NEW_PAYMENT = '/:country/new-payment';
export const TERMS = '/:country/terms';
export const MY_ACCOUNT = '/:country/home/user';
export const SEARCH = '/:country/search';
export const TALENT = '/:country/talent/:id';

// the node root for musica, does not register this route
export const ROOT_MUSICA = '/:country/cmusica';
export const ROOT_MUSICA1 = '/:country/musica';
// [GET] all playlists available
export const BROWSE_MUSICA = `/:country/cmusica/browse`;
// [GET] a specific playlist
export const PLAYLIST_DETAIL = `/:country/cmusica/playlist/:playlist_id`;
export const PLAYLIST_DETAIL_CAROUSEL = `/:country/playlist/:playlist_id`;
// [GET] play songs from a playlist
export const PLAYER_MUSICA = `/:country/cmusica/playing/:playlist_id/:song_id`;
export const PLAYER_MUSICA_CAROUSEL = `/:country/playing/:playlist_id/:song_id`;

export const EVENT_CARD_NODE_ID = '/:country/event/:eventId';

export const CARD = '/:country/vcard/:groupId';
export const CARD_NODE = '/:country/vcard/:nodeId/:titleUri/:groupId';
export const CARD_NODE_ID = '/:country/vcard/:nodeId/:groupId';

// ----Mundial Qatar----
export const MATCH_CARD = '/:country/vcard/match/:matchId';
export const PLAYER_CARD = '/:country/vcard/player/:playerId';
export const TEAM_CARD = '/:country/vcard/team/:teamId';

export const PLAYERINAPP = '/:country/devices';
export const TUTOVIDEO = '/:country/videotutoriales';
export const TUTOS = '/:country/tutoriales';
export const PROFILE = '/:country/socialProfile/:socialId';
export const MYPROFILE = '/:country/socialProfile';
export const CARD_DOWNLOAD = ':country/download/:groupId';
export const INFINITE_LIST = ':country/:node';
export const LOGIN = ':country/login';
export const REMINDER = ':country/reminder';
export const RESET_PASSWORD = ':country/reset-password';
export const HOME_USER = '/:country/:node';
export const DEV_STATS = '/dev/stats';
export const IP_TELMEX_REGISTER = '/:country/userdetectwsregister';
export const IP_TELMEX_CONFIRM = '/:country/userdetectwsconfirm';
export const IP_TELMEX_ACTIVATE = '/:country/iptelmexactivate';
export const REDIRECT = ':country/login_redirect';
export const OAUTH_CALLBACK = '/net/oauth_callback_login';
export const TERMS_CONDITIONS = '/terminos_y_condiciones';
export const FIRETV_SUPPORT = '/support';
export const POLITICAS_DE_PRIVACIDAD = '/politicas_de_privacidad';
export const FINAL_USER_LICENSE = '/licencia_usuario_final';
export const MIN_REQ = '/requerimientos_minimos';
export const PROM_TERMS = '/terminos_promociones';
export const TUTORIALS = '/tutoriales';
export const FAQS = '/faqs';
export const GTRES = '/gtres';
export const APPLEATTACH = '/:country/loginapplecallback';
export const APPLEIDLOGIN = '/:country/applesignin';
export const FORGOTTEN_PASSWORD = '/forgottenPassword';

export const PLAYER = `/:country${PLAYER_SEGMENT}:groupId`;

export const WHAT_INCLUDES_ROUTE = `/:country/whatincludes/:family`;
export const PLAN_SELECT_ROUTE = `/:country/planselect/:family`;

// Route for set email to IPTV users
export const COMPLETE_IPTV = '/:country/completa';

//TODO: tEMP Route for premium
export const PREMIUM = '/:country/premium-web';
export const HELP_CENTER = '/:country/home/help';
export const VIDEO_TUTORIALS = '/:country/home/help/video-tutorials';
export const VIDEO_TUTORIALS_DEVICE = '/:country/home/help/video-tutorials/:deviceId';
export const VIDEO_TUTORIAL_PLAY = '/:country/home/help/video-tutorials/:deviceId/:videoType';
export const INSTALLATION_MANUALS = '/:country/home/help/installation-manuals';
export const INSTALLATION_MANUAL_VIEW = '/:country/home/help/installation-manuals/:deviceId';
export const INSTALLER = '/:country/home/help/installer';
export const INSTALLER_MANUAL = '/:country/home/help/installer/manuals/:deviceId';
export const INSTALLER_VIDEO_DEVICE = '/:country/home/help/installer/videos/:deviceId';
export const INSTALLER_VIDEO_PLAY = '/:country/home/help/installer/videos/:deviceId/:videoType';
export const RECOVERY_PASSWORD = '/:country/recoveryPassword';
export const RECOVERY_PASSWORD_COMPLETED =
  '/:country/recoveryPasswordCompleted';
  //OTP: Login de apps
export const OTP_TELMEX_REGISTER = '/registrotelmex';
export const OTP_REGISTER = '/registro';
export const OTP_LOGIN = '/iniciosesion';
export const HBO_ACTIVATION = '/activahbo';
export const HBO_COMMUNICATION = HBO_COMMUNICATION_PATH;
export const EXTERNAL_APP_LOGIN = '/:country/app-login';
export const EXTERNAL_APP_REGISTER = '/:country/app-register';
export const EXTERNAL_APP_LANDING ="/:country/onboarding"
//WEBVIEW PAGOS
export const PAYMENT_MOBILE = '/:country/payment-mobile';
export const PBI_DEEPLINK = '/:country/pbi';
// PAYPAL RETURN / CANCEL — URLs configuradas en paypalgate_configuration
// TVOD
export const PAYPAL_TVOD_CONFIRM = '/paypal/tvod/confirm';
export const PAYPAL_PURCHASE_CHECKOUT_RETURN = '/paypal/purchase-checkout/return';
export const PAYPAL_PURCHASE_CHECKOUT_CANCEL = '/paypal/purchase-checkout/cancel';
// SVOD
export const PAYPAL_SVOD_RETURN_URL = '/paypal/svod/returnUrl';
export const PAYPAL_SUBSCRIPTION_CHECKOUT_RETURN = '/paypal/subscription-checkout/return';
export const PAYPAL_SUBSCRIPTION_CHECKOUT_CANCEL = '/paypal/subscription-checkout/cancel';

// QR VINCULACION
export const QR_LINKING = '/agregarmdp';
export const QR_LINKING_EDIT = '/editarmdp';
export const QR_LINKING_ACCOUNT = '/validar-cuenta';
export const QR_LINKING_PAYMENT_METHOD = '/vincular-metodo-pago';
export const QR_LINKING_CALL_CENTER = '/vincular-call-center';
export const QR_LINKING_LINKING_ERROR = '/error-vinculacion';
export const QR_LINKING_LINKING_EXCEEDED_TRIES = '/intentos-excedidos';
export const QR_LINKING_LINKING_ERROR_TIME_EXCEEDED = '/tiempo-excedido';
